import { Link, useLocation } from 'react-router-dom';
import { preloadFunctions } from '../App';

type SectionKey = keyof typeof preloadFunctions;

interface NavItem {
  path: string;
  label: string;
  preloadKey: SectionKey;
}

const navItems: NavItem[] = [
  { path: '/albums', label: 'ALBUMS', preloadKey: 'albums' },
  { path: '/books', label: 'BOOKS', preloadKey: 'books' },
  { path: '/places', label: 'PLACES', preloadKey: 'places' },
  { path: '/playlists', label: 'PLAYLISTS', preloadKey: 'playlists' },
  { path: '/elsewhere', label: 'ELSEWHERE', preloadKey: 'elsewhere' },
  { path: '/about', label: 'ABOUT', preloadKey: 'about' },
];

const NavBar: React.FC = () => {
  const location = useLocation();

  const handleMouseEnter = (preloadKey: SectionKey) => {
    // Preload the component on hover for instant navigation
    preloadFunctions[preloadKey]();
  };

  return (
    <nav className="flex flex-wrap gap-2 md:gap-4 mb-6 text-xl md:text-2xl font-semibold -ml-2 md:-ml-3">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          onMouseEnter={() => handleMouseEnter(item.preloadKey)}
          className={`transition-all duration-200 px-2 md:px-3 py-1 rounded-full ${
            location.pathname === item.path
              ? "bg-black text-white"
              : "text-gray-600 hover:text-black"
          }`}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

export default NavBar;
